export const config = {
  siteName: import.meta.env.VITE_SITE_NAME || 'The Picks Club',
  siteUrl: import.meta.env.VITE_SITE_URL || 'https://example.com',
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8787',
  demoMode: import.meta.env.VITE_DEMO_MODE !== 'false',
  premiumEnabled: import.meta.env.VITE_PREMIUM_ENABLED === 'true',
};
